export default __webpack_public_path__ + "static/media/logo20.f130097c.svg";